module.exports = __webpack_public_path__ + "img/export.fdd10e72.svg";